import { FormattedMessage } from 'react-intl';
import Dialog from '@rio-cloud/rio-uikit/Dialog';

import { EngineOilPreconditions, FillLevelType } from '@/generated/fleetAggregationServiceTypes';
import EngineOilDidDynamicPreconditionsElement from './EngineOilDidDynamicPreconditionsElement';
import EngineOilDidPreconditionsElement from './EngineOilDidPreconditionsElement';
import EngineOilSensorSignalV2PreconditionsElement from './EngineOilSensorSignalV2PreconditionsElement';

type EngineOilPreconditionsDialogProps = {
    openDialog: boolean;
    closeDialog: () => void;
    engineOilType: string;
    engineOilPreconditions?: EngineOilPreconditions;
};

const EngineOilPreconditionsDialog = ({ openDialog, closeDialog, engineOilType, engineOilPreconditions }: EngineOilPreconditionsDialogProps) => (
    <Dialog
        body={
            openDialog ? (
                <div className="prediction-dialog-chart padding-x-20 padding-bottom-10">
                    {engineOilType === FillLevelType.EngineOilV2 && <EngineOilSensorSignalV2PreconditionsElement />}
                    {engineOilType === FillLevelType.EngineOilDid &&
                        (engineOilPreconditions ? (
                            <EngineOilDidDynamicPreconditionsElement engineOilPreconditions={engineOilPreconditions} />
                        ) : (
                            <EngineOilDidPreconditionsElement />
                        ))}
                </div>
            ) : null
        }
        title={<FormattedMessage id="intl-msg:fleetstatus.diagnostics.sidebar.section.engine_oil.state.preconditions.dialog.title" />}
        show={openDialog}
        showCloseButton
        onClose={closeDialog}
        footer={null}
        bsSize={engineOilType === FillLevelType.EngineOilDid && !engineOilPreconditions ? Dialog.SIZE_SM : undefined}
    />
);

export default EngineOilPreconditionsDialog;
